import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const useFadeUp = (options = {}) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const tween = gsap.fromTo(
      el,
      { opacity: 0, y: 28 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        delay: options.delay || 0,
        scrollTrigger: { trigger: el, start: "top 85%", once: true },
      }
    );
    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
    };
  }, []); // eslint-disable-line
  return ref;
};

export const Reveal = ({ children, className = "", delay = 0, ...rest }) => {
  const ref = useFadeUp({ delay });
  return (
    <div ref={ref} className={className} style={{ opacity: 0 }} {...rest}>
      {children}
    </div>
  );
};

export const openChat = () => {
  if (window.leadConnector?.chatWidget?.openWidget) {
    window.leadConnector.chatWidget.openWidget();
    return;
  }
  const btn = document.querySelector("chat-widget")?.shadowRoot?.querySelector("button");
  if (btn) btn.click();
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
